/* global ga */

const googleAnalyticsSearchResults = {
    init : function (config) {
        var self = this;

        var data = config.data;
        var url = config.url;

        if (1 === parseInt(data.pageNumber, 10) && data.isOurSiteUser) {
            self.sendGoogleAnalyticsEventIfFirstPage(data.totalItems, url);
        }
    },
    sendGoogleAnalyticsEventIfFirstPage: function (totalItems, url) {
        var self = this;
        if (typeof ga !== 'undefined') {
            url ? url = window.location.protocol + '//' + window.location.hostname + url : url = window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search;
            ga('send', 'event', 'Rezultati pretrage', 'Rezultati', totalItems.toString(),{ location: url });
        }
    }
};

export default googleAnalyticsSearchResults;
